import cx from 'classnames';

interface Props {
  styles?: any;
  children?: any;
  className?: any;
}

const AccordianSectionBody = ({ styles, children, className }: Props) => (
  <div className={cx(styles.body, className)}>{children}</div>
);

export default AccordianSectionBody;



// WEBPACK FOOTER //
// ./components/ui/accordian/accordianSectionBody.tsx